import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
	// we init with resources
	resources: {
		es: {
			translations: {
				'common.ccu': 'CCU Argentina',
				'layout.menu.we': 'Nosotros',
				'layout.menu.values': 'Principios',
				'layout.menu.areas': 'Áreas',
				'layout.menu.trademarks': 'Nuestras Marcas',
				'layout.menu.sutentability': 'Sustentabilidad',
				'layout.menu.experience': 'Experiencia CCU',
				'layout.menu.opportunities': 'Oportunidades Laborales',
				'home.herosection.title': 'Haz parte de nuestra cultura única',
				'home.herosection.subtitle1': '#BEER',
				'home.herosection.subtitle2': 'OFFICE',
				'home.herosection.apply': 'APLICA AQUÍ',
				'home.weare.title': '¿QUIERES SABER CÓMO VIVIMOS NUESTRA CULTURA',
				'home.weare.hashtag_b': 'BEEROFFICE',
				'home.weare.hashtag_e': 'EN',
				'home.values.title': 'NUESTROS',
				'home.values.subtitle': 'VALORES',
				'home.values.subtitle2': 'SON:',
				'home.values.value1': 'APASIONADOS',
				'home.values.value2': 'RESUELTOS',
				'home.values.value3': 'COMPROMETIDOS',
				'home.values.value4': 'ÍNTEGROS',
				'home.values.value1_exp':
					'Como dueños, nos apasionamos con nuestro trabajo. Estamos dedicados a hacer todo con gran energía, que sumada motiva a todos a nuestro alrededor.',
				'home.values.value2_exp':
					'Soñamos en grande y la experiencia nos ha demostrado que es posible hacerlo. Creemos que siempre se puede hacer más y mejor.',
				'home.values.value3_exp':
					'La sostenibilidad es nuestro negocio y como parte de la solución, trabajamos para fortalecerla entre nuestros consumidores, el ambiente y las comunidades en las que vivimos y operamos.',
				'home.values.value4_exp':
					'Nunca tomamos atajos. Lideramos con el ejemplo y nos enfocamos en lo que realmente importa, operando de una manera ética, honesta y directa.',
				'home.transform.message1': '"NUESTRO SUEÑO',
				'home.transform.message2': 'ES TRANSFORMAR A',
				'home.transform.message3': 'COLOMBIA"',
				'home.talent_program.title': 'PROGRAMAS DE TALENTO',
				'home.reto.title': '¿ESTÁS LISTO PARA ASUMIR EL RETO?',
				'home.reto.subtitle': '#BEEROFFICE',
				'footer.follow': 'Síguenos en nuestras Redes Sociales',
				'home.programs.program1': 'Ab inBev Trainee',
				'home.programs.program1_exp': 'Es un programa de desarrollo dirigido a universitarios recién egresados, en donde se brindará la oportunidad de ingresar a laborar y rotar por diferentes áreas de la Empresa en un periodo de 10 meses adquiriendo una constante capacitación, retos y diversas responsabilidades, para finalmente tener la oportunidad de ocupar una posición desafiante dentro de la estructura de la Compañía.',
				'home.programs.program2': 'TALENTOS COMERCIALES',
				'home.programs.program2_exp': 'Inicia con un entrenamiento de dos semanas para entender el funcionamiento general del negocio, para después estar dos semanas de lleno en la operación comercial y así poder incorporarse a una posición de liderazgo de un equipo de vendedores altamente calificado, con la responsabilidad del desarrollo de la zona que haya sido asignada.',
				'home.programs.program3': 'TALENTOS LOGÍSTICA',
				'home.programs.program3_exp': 'Luego de inducción, los participantes estarán inmersos en nuestra operación de almacenamiento y reparto, y luego asumirán el rol de profesional de Despachos en uno de nuestros Centros de Distribución del país.',
				'home.programs.program4': 'TALENTOS SUPPLY',
				'home.programs.program4_exp': 'Durante un mes conocerán el contexto general del negocio y una inducción al área específica (Seguridad, Maltería, Elaboración, Envasado, Calidad e Ingeniería, Servicios Industriales y Sostenibilidad).',
				'home.programs.program5': 'PRACTICANTES',
				'home.programs.program5_exp': 'Buscamos practicantes que aspiren a tener la oportunidad de vivir la cultura única de Bavaria, que estén dispuestos a sumir retos en diferentes áreas y que sueñen en grande. Trabajar en Bavaria y asumir el reto #BeerOffice es alcanzar todo tu potencial y demostrar tus habilidades, mientras disfrutas lo que haces.',
				'home.pilares.pilar1.pilar': 'PILAR 1',
				'home.pilares.pilar1.title': 'NUESTRA',
				'home.pilares.pilar1.subtitle': 'GENTE',
				'home.pilares.pilar1.exp1': 'NO ES CASUALIDAD QUE',
				'home.pilares.pilar1.exp2': 'NUESTRA GENTE',
				'home.pilares.pilar1.exp3': 'SEA EL PRIMER PILAR',
				'home.pilares.pilar2.pilar': 'PILAR 2',
				'home.pilares.pilar2.title': 'CRECIMIENTO',
				'home.pilares.pilar2.p1': '· Si a nosotros nos va bien, a Colombia le va bien.',
				'home.pilares.pilar2.p2': '· Generamos 4.000 empleos directos y 80.000 empleos indirectos.',
				'home.pilares.pilar2.p3': '· Representamos el 1% del PIB del país por nuestro pago de impuestos.',
				'home.pilares.pilar2.exp1': 'NUESTRO ÉXITO',
				'home.pilares.pilar2.exp2': 'MULTIPLICA EL PROGRESO',
				'home.pilares.pilar2.exp3': 'DE COLOMBIA',
				'home.pilares.pilar3.pilar': 'PILAR 3',
				'home.pilares.pilar3.title': 'IMPACTO EN LAS',
				'home.pilares.pilar3.subtitle': 'COMUNIDADES',
				'home.pilares.pilar3.exp1': 'LA SOSTENIBILIDAD NO HACE PARTE DE NUESTRO NEGOCIO,',
				'home.pilares.pilar3.exp2': 'ES NUESTRO NEGOCIO',
				'home.pilares.pilar3.p1': '· Estamos aquí para transformar nuestro país.',
				'home.pilares.pilar3.p2': '· Colombia espera que hagamos cosas grandes, que impacten significativamente nuestras comunidades.',
				'home.pilares.pilar3.p3': '· Creciendo por un sueño.',

			},
		},
	},
	fallbackLng: 'es',
	debug: true,

	// have a common namespace used around the full app
	ns: ['translations'],
	defaultNS: 'translations',

	keySeparator: false, // we use content as keys

	interpolation: {
		escapeValue: false, // not needed for react!!
		formatSeparator: ',',
	},

	react: {
		wait: true,
	},
});

export default i18n;
